import { closeModal } from 'actions/modal';
import { unarchiveHub, unarchiveKit, unarchiveTemplate } from 'actions/requests';
import Button from 'components/atoms/Button';
import Typography from 'components/atoms/Typography';
import { DiscoverItemDescriptor, DiscoverItemType } from 'utils/gloo-types';
import { startCase } from 'lodash';
import { toast } from 'react-toastify';
import { useThunkDispatch } from 'utils/reduxHook';
import ModalWrapper from './ModalWrapper';

type UnarchiveDiscoverItemModalProps = {
  descriptor: DiscoverItemDescriptor;
  onArchivedAtChange: (archivedAt?: Date) => void;
};

const UnarchiveDiscoverItemModal = ({ descriptor, onArchivedAtChange }: UnarchiveDiscoverItemModalProps) => {
  const dispatch = useThunkDispatch();

  const formattedDiscoverItemType = startCase(descriptor.type);

  const onCancel = () => {
    dispatch(closeModal());
  };

  const onUnarchive = async () => {
    switch (descriptor.type) {
      case DiscoverItemType.HUB:
        await dispatch(unarchiveHub(descriptor.id));
        break;
      case DiscoverItemType.KIT:
        dispatch(unarchiveKit(descriptor.id));
        break;
      case DiscoverItemType.TEMPLATE:
        await dispatch(unarchiveTemplate(descriptor.id));
        break;
    }
    onArchivedAtChange(null);
    toast.info(`You successfully unarchived your ${formattedDiscoverItemType}`);
    dispatch(closeModal());
  };

  return (
    <ModalWrapper closeOnEscapeKey closeOnBackgroundClick>
      <div className="flex flex-col gap-6">
        <Typography variant="h1">Are you sure?</Typography>
        <Typography variant="base">
          Are you sure you want to unarchive your {formattedDiscoverItemType}? Your {formattedDiscoverItemType} will
          have the ability to be featured and displayed in Discover.
        </Typography>
        <div>
          <div className="flex flex-row gap-4 justify-end">
            <Button type="tertiary" dataDurableId="unarchiveDiscoverItemModalCancelButton" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="navy" dataDurableId="unarchiveDiscoverItemModalUnarchiveButton" onClick={onUnarchive}>
              Unarchive {formattedDiscoverItemType}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default UnarchiveDiscoverItemModal;
